import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  open(event) {
    event.preventDefault();

    const trigger = event.currentTarget;
    const title = trigger.dataset.modalTitle;
    const message = trigger.dataset.modalMessage;
    const btnText = trigger.dataset.modalBtnText;
    const btnColor = trigger.dataset.modalBtnColor || 'green';
    const form = trigger.closest('[data-modal-form]') || trigger.nextElementSibling;

    const overlay = document.querySelector('.x-cert-confirm-overlay');
    const modal = document.querySelector('.x-cert-confirm-modal');

    if (!overlay || !modal) return;

    modal.querySelector('.x-cert-confirm-title').textContent = title;
    modal.querySelector('.x-cert-confirm-message').textContent = message;

    const btn = modal.querySelector('.x-cert-confirm-btn');
    btn.textContent = btnText;
    btn.className = `btn ${btnColor} btn--ok x-cert-confirm-btn`;
    btn.onclick = () => {
      this.close();
      if (trigger.dataset.modalFormId) {
        document.getElementById(trigger.dataset.modalFormId).submit();
      }
    };

    overlay.style.display = '';
    modal.style.display = '';
    document.body.style.overflow = 'hidden';

    modal.querySelectorAll('.x-cert-confirm-close').forEach((el) => {
      el.onclick = (e) => {
        e.preventDefault();
        this.close();
      };
    });
  }

  close() {
    const overlay = document.querySelector('.x-cert-confirm-overlay');
    const modal = document.querySelector('.x-cert-confirm-modal');
    if (overlay) overlay.style.display = 'none';
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
  }
}
